
import { useCredentialsLoader } from "./hooks/useCredentialsLoader";
import { useCredentialsSaver } from "./hooks/useCredentialsSaver";
import { useConnectionTester } from "./hooks/useConnectionTester";

export const useApiSettings = () => {
  const {
    platformStates,
    setPlatformStates,
    loadingCredentials,
    refreshCredentials
  } = useCredentialsLoader();

  const { isSubmitting, handleSaveCredentials } = useCredentialsSaver(
    platformStates,
    setPlatformStates
  );

  const { handleTestConnection } = useConnectionTester(
    platformStates,
    setPlatformStates
  );

  const handleInputChange = (platformId: string, fieldName: string, value: string) => {
    setPlatformStates(prev => ({
      ...prev,
      [platformId]: {
        ...prev[platformId],
        credentials: {
          ...prev[platformId].credentials,
          [fieldName]: value
        },
        status: 'idle'
      }
    }));
  };

  return {
    isSubmitting,
    platformStates,
    loadingCredentials,
    handleInputChange,
    handleSaveCredentials,
    handleTestConnection,
    refreshCredentials
  };
};
